export const TRAINING_CENTER_LINK_CLASSES = 'text-[#245682] hover:text-[#142f46] hover:underline focus:underline focus:outline focus:outline-2 focus:outline-offset-[3px] focus:outline-[#428BCA]'

export const TRAINING_CENTER_HEADING_CLASSES = 'mb-[10px] text-[1.2rem] font-medium leading-[1.1] text-[#424141]'
